import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThirdPartiesSourcesListComponent } from './third-parties-sources-list/third-parties-sources-list.component';
import { ThirdPartiesSourcesDetailComponent } from './third-parties-sources-detail/third-parties-sources-detail.component';

const routes: Routes = [
    {
        path: 'thirdPartiesSources',
        children: [
            { path: '', component: ThirdPartiesSourcesListComponent }
        ]
    },
    {
        path: 'thirdPartiesSources/:id',
        children: [
            { path: '', component: ThirdPartiesSourcesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],

    exports: [RouterModule]
})
export class ThirdPartiesSourcesRoutingModule { }
